import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Order from '../../redux/actions/orderAction'
import { Http,urls } from '../../api/index'
import storage from 'store'
import moment from 'moment'
import CarComponents from '../../component/order/CarComponents'
import { NavBar, Modal, Checkbox, InputItem, Toast, Icon } from 'antd-mobile'
import NavBarComponent from '../../component/common/NavBarComponent'
import './order.scss';
import { removeArray, removeEmptyAttr, parseSearchToState, parseStateToSearch, throttle } from '../../util/util';
const CheckboxItem = Checkbox.CheckboxItem;

class OrderPage extends Component {
  constructor(props){
    super(props);
    this.state = {
      order: {
        basicFees: [],
        optionalFees: [],
        paymentMethods: []
      },
      agreeContract: false,
      basicFeesAmount: 0,  // 基础费用
      optionalAmouunt: 0, // 可选费用
      optionalArray: [],
      optionalCodeArray: [],
      payType: '',
      couponId: '',
      text: '',
      subHidden: true,
      yfhidden: false,
      isTotal: false,
      firstpayRentalAmount: 0,
      agree: true,
      couponNum: 0
    }
    this.throttleSummit = throttle(()=>{this.onSubmit()}, 3000)
  }

  componentDidMount() {
    const param = parseSearchToState(this.props.location.search)
    this.props.dispatch(Order.orderPass(param)).then(res => {
      this.getDetail()
    })
    // this.props.dispatch(Order.orderEdit({backCityName: '上海'})).then(res => {})
  }
  componentWillUnmount() {
    this.props.dispatch(Order.orderCouponRemove())
    this.props.dispatch(Order.orderClear())
  }
  componentWillReceiveProps(props) {
    if (props.orderReducer.couponId) {

    }
  }
  getDetail() {
    const { orderReducer } = this.props
    const user = storage.get('user') || {}
    let url = urls.orderPage;
    let data = {
      orderProdType: 'D',
      bookingUserId: user.userId,
      bookingCargradeId: orderReducer.param.bookingCarGradeId,
      bookingCarmodelId: orderReducer.param.bookingCarmodelId,
      bookingGaincarTimeStr: moment(orderReducer.param.bookingGaincarTime).format('YYYYMMDDHHmm').padEnd(14, '0'),
      bookingGaincarStoreId: orderReducer.param.gaiStoreId,
      bookingBackcarTimeStr: moment(orderReducer.param.bookingBackcarTime).format('YYYYMMDDHHmm').padEnd(14, '0'),
      bookingBackcarStoreId: orderReducer.param.backStoreId
    }
    Http.post({ url, data }).then(res => {
      let priceAll = 0;  // 价格计价总价格(单位：元)
      let busireduceAll = 0; // 企业用户抵扣金额

      res.data.basicFees.forEach((item) => {
        priceAll += item.totalPriceAmount
        busireduceAll += item.businessDeductAmount
      })

      this.setState({
        order: res.data,
        payType: res.data.paymentMethods[0].payMethodCode,
        yfhidden: res.data.paymentMethods[0].payMethodCode !== 'online_fully_pay',
        isTotal: res.data.paymentMethods[0].payMethodCode !== 'goto_store_pay',
        basicFeesAmount: res.data.paymentMethods[0].payMethodCode === 'goto_store_pay' ? 0 : (priceAll - busireduceAll)
      })
      this.props.dispatch(Order.orderInfo(res.data))
      this.getCouponNum()
    })
  }

  // 获取优惠券
  getCouponNum() {
    let url = urls.useCoupon;
    let data = {
      modelId: this.state.order.bookingCarmodelId, 
      orderSnapshotId: this.state.order.orderSnapshotId,
      paymentType:this.state.payType === 'goto_store_pay' ? 1 : 0, 
      priceCodesStr: [...this.state.order.basicFees.map(item => {return item.priceCode}), ...this.state.optionalCodeArray].join(','),
      productType: 'D',
      storeId: this.state.order.bookingGaincarStoreId,
      tenancy: this.state.order.bookingRentalDays,
      total: this.state.payType === 'online_partly_yufu_pay' ? this.state.order.firstpayRentalAmount : this.state.basicFeesAmount + this.state.optionalAmouunt
    }
    Http.post({url, data}).then(res => {
      this.setState({
        couponNum: res.data.availableQuantity
      })
    })
  }

  openModal(e,text) {
    Modal.alert('费用说明', text, [
      { text: '确定', onPress: () => {} }
    ])
  }

  _basicFees() {
    return <div>
      <div className="basic fs24 weight">基本费用</div>
      {this.state.order.basicFees.map((item,index) => {
       return <div className="footer-row mt10" key={index}>
        <div className="row-name">
          <span>{item.priceName}</span>
          {item.priceDescTips !== '' && 
          <span onClick={(e) => this.openModal(e,item.priceDescTips)} className='iconfont icon-warn' style={{fontSize:'12px',color:'#f00'}}>
          </span>}
          {item.priceDescMemo !== '' && <div className="bcxwa">{item.priceDescMemo}</div>}
          {item.marketPromotionTag !== '' && <div className="bmiaoshu">{item.marketPromotionTag}{item.marketPromotionTag.length>0}</div>}
        </div>
        <div className="row-icon">
          <span>{item.priceAmount}x{item.quantity}</span>
          <span>￥{item.totalPriceAmount}</span>
        </div>
      </div>
      })}
    </div>
  }

  onChange(e, item) {
    this.props.dispatch(Order.orderCouponRemove())
    let checked = e.target.checked
    let code = `${item.priceCode}@${item.totalPriceAmount}`;
    let amount = this.state.optionalAmouunt
    if (checked) {
      this.setState({
        optionalAmouunt: amount + item.totalPriceAmount,
        optionalArray: [...this.state.optionalArray, code],
        optionalCodeArray: [...this.state.optionalCodeArray, item.priceCode]
      }, () => {
        this.getCouponNum()
      })
    } else {
      let arr = removeArray(this.state.optionalArray, code)
      let arrCode = removeArray(this.state.optionalCodeArray, item.priceCode)
      this.setState({
        optionalAmouunt: amount - item.totalPriceAmount,
        optionalArray: arr,
        optionalCodeArray: arrCode
      }, () => {
        this.getCouponNum()
      })
    }
  }

  _optionalFees() {
    return <div>
    {this.state.order.optionalFees.length>0 && <div className="basic fs24 weight mb10">可选服务</div>}
    <div className="fs28">
      <div>
        <div>
        {this.state.order.optionalFees.map((item, index) => {
          return  <CheckboxItem className="service" key={index} onChange={(e) => this.onChange(e,item)}>
            <div className="footer-row" key={index}>
            <div className="row-name">
              <span>{item.priceName}</span>
              {item.priceDescTips !== '' && 
                <span className='iconfont icon-warn' style={{fontSize:'12px',color:'#f00'}} onClick={(e) => this.openModal(e,item.priceDescTips)}></span>}
              {item.priceDescMemo !== '' && <div className="cxwa">{item.priceDescMemo}</div>}
              {item.marketPromotionTag !== '' &&  <div className="miaoshu">{item.marketPromotionTag}</div>}
            </div>
            <div className="row-icon">
              <span>{item.priceAmount}*{item.quantity}</span>
              <span>￥{item.totalPriceAmount}</span>
            </div>
          </div>
        </CheckboxItem>
        })}
        </div>
      </div>
    </div>
    </div>
  }

  onChangeRadio(item) {
    if (item === 'goto_store_pay') {
      this.setState({
        yfhidden: true,
        payType: item
      })
    } else {
      this.setState({
        payType: item,
        yfhidden: false
      })
    }
    this.getCouponNum()
  }

  _payMethods() {
    return  <div>
      <div className="basic fs24 weight">支付方式</div>
      <div className="footer-row fs28">
        <div className="row-name">
          {this.state.order.paymentMethods.map(item => {
            return <div key={item.payMethodCode} className='radio'>
                <span 
                  className={['am-checkbox', this.state.payType === item.payMethodCode ? 'am-checkbox-checked' : ''].join(' ')}
                  onClick={() => this.onChangeRadio(item.payMethodCode)}>
                  <input type="checkbox" className="am-checkbox-input"/><span className="am-checkbox-inner"></span>
                </span>
                <span className="label">{item.payMethodName}</span>
                <span className="payText">({item.payMethodTips})</span>
              </div>
          })}
        </div>
      </div>
      <div className="line mt12 mb12"></div>
    </div>
  }

  goCost() {
    // if (this.state.couponNum === 0) {
    //   return
    // }
    let baseJsonArray = this.state.order.basicFees.map(item => {
      return {priceCode: item.priceCode, price: item.totalPriceAmount}
    })
    let optionsJsonArray = []
    this.state.order.optionalFees.forEach(item => {
      if (this.state.optionalCodeArray.includes(item.priceCode)){
        optionsJsonArray.push({priceCode: item.priceCode, price: item.totalPriceAmount})
      }
    })

    const { orderReducer } = this.props
    const data = {
      type: 'order',
      total: this.state.basicFeesAmount + this.state.optionalAmouunt,
      priceItemsJson: JSON.stringify([...baseJsonArray, ...optionsJsonArray]).replace('[', '(').replace(']', ')'),
      tenancy: this.state.order.bookingRentalDays,
      productType: 'D',
      storeId: orderReducer.order.bookingGaincarStoreId,
      modelId: orderReducer.order.bookingCarmodelId,
      paymentType: this.state.payType === 'goto_store_pay' ? 1 : 0, 
      orderSnapshotId:this.state.order.orderSnapshotId
    }
    this.props.history.push('/couponList' + parseStateToSearch(data))
    // this.props.history.push({
    //   pathname: '/couponList',
    //   query: data
    // })
  }

  _couponType() {
    return <div className="beizhu basic">
      <div className="weight fs28">优惠类型</div>
      <div onClick={()=>this.goCost()} className="free">
        <span className='c9'>暂无优惠</span>
        <span className="iconfont icon-more"></span>
      </div>
  </div>
  }

  _coupon() {
    const { couponInfo }  = this.props.orderReducer
    return <div className="beizhu basic">
      <div className="weight fs28">优惠券</div>
      <div onClick={()=>this.goCost()} className="free">
       {this.state.couponNum === 0 && <span>暂无可用</span>}
       {(this.state.couponNum !== 0 && couponInfo.code) && <span>减{couponInfo.reducedTotalPrice}</span> } 
       {(this.state.couponNum !== 0 && !couponInfo.code) && <span>{this.state.couponNum}张可用</span>}
        <span className="iconfont icon-more"></span>
      </div>
  </div>
  }
  goIframe({url, title}) {
    this.props.history.push({
      pathname: '/webview',
      query: {url, title}
    })
  }
  _deposit() {
    return <div><div className="deposit">
      <div>
        <p className="weight font12">车辆押金{this.state.order.carDepositAmount}元+违章押金{this.state.order.weizhangDepositAmount}元</p>
        <p className='bcxwa font12 mt5'>您需要在取车时支付车辆押金，点击
          <span onClick={() => this.goIframe({url: 'https://h5.izuche.com/h5/deposit.html', title: '押金支付及免押规则'})}>《押金支付及免押规则》</span></p>
      </div>
    </div>
    <div className='tip'>"请确保您的身份证、驾驶证有效期＞还车日期+30天，否则将影响您用车~"</div>
    <CheckboxItem className="agree" checked={this.state.agreeContract} 
      onChange={(e) => {
        const order = this.state.order 
        order.agreeContract = e.target.checked
        this.setState({
          order,
          agreeContract: !this.state.agreeContract
        })}}>
            <p>我已阅读<span onClick={()=>this.goIframe({url: 'https://h5.izuche.com/h5/rentalAndRefundRules.html', title: '租车说明及退款规则'})}>《租车说明及退款规则》</span></p>
    </CheckboxItem>
  </div>
  }

  _renderFooter() {
    const { couponInfo }  = this.props.orderReducer
    return <div>
      {this.state.subHidden && <div className="subOrder">
      <div>
      {this.state.yfhidden && 
        <div className="yf">预付金额:
          <span>￥{this.state.order.firstpayRentalAmount}</span>
        </div>}
      {this.state.isTotal && 
        <div className="yfze">预计总额:
          <span>￥{parseFloat((this.state.basicFeesAmount + this.state.optionalAmouunt - (couponInfo.reducedTotalPrice || 0)).toFixed(2))}</span>
        </div>}
        </div>
      <div className="tj" onClick={()=>{this.throttleSummit()}}> 提交</div>
    </div>}
    </div>
  }

  onSubmit() {
    if(!this.state.agreeContract) {
      Toast.info('请先阅读并勾选“租车说明及退款规则”', 1, null, false);
      return
    }
    const { couponInfo }  = this.props.orderReducer
    const baseArray = this.state.order.basicFees.map(item => {
      return `${item.priceCode}@${item.totalPriceAmount}`
    })
    const user = storage.get('user')
    let url = urls.submitOrder;
    let data = removeEmptyAttr({
      orderSnapshotId: this.state.order.orderSnapshotId, 
      couponId: couponInfo.code || '',
      payMethodCode: this.state.payType,
      bookingUserId: user.userId,
      priceDetails: [...baseArray,...this.state.optionalArray].join(','),
      trafficNumber: this.state.text
    });
    Http.post({url, data}).then(res => {
      if (this.state.payType === 'goto_store_pay') {
        // 门店支付直接跳转订单页
        this.props.dispatch(Order.orderCouponRemove())
        this.props.dispatch(Order.orderClear())
        this.props.history.replace('/routeOrderList')
      } else {
        const param = {
          orderNo: res.data.orderNo,
          billNo: res.data.billNo,
          price: parseFloat((this.state.basicFeesAmount + this.state.optionalAmouunt - (couponInfo.reducedTotalPrice || 0)).toFixed(2))
        }
        storage.remove('serialNo')
        window.location.replace(`/payment${parseStateToSearch(param)}`)
      }
    })
  }

  render() {
    const {order,param}  = this.props.orderReducer
    return <div id='order' className='page'>
        <NavBarComponent>
          <NavBar 
          icon={<Icon type="left" color='#333' />} 
          onLeftClick={() => {this.props.history.goBack()}}
          mode='light'>确认订单</NavBar>
       </NavBarComponent>
        <div className='content'>
          <CarComponents data={Object.assign({},param,order)}/>
          <div className='beizhu mt20'>
              <span className='c3'>备注信息：</span>
              <InputItem
                prefixListCls="input_phone"
                value={this.state.text}
                maxLength={10}
                placeholder="请输入航班号/车次号"
                onChange={(text)=>this.setState({text})}
                clear
              />
          </div>
          <div className="line mt12 mb12"></div>
          {this._basicFees()}
          <div className="line mt12 mb12"></div>
          {this._optionalFees()}
          {this.state.order.optionalFees.length > 0 && <div className="line mt12 mb12"></div>}
          {this._payMethods()}
          {/*{this._couponType()}
          <div className="line mt12 mb12"></div>*/}
          {this._coupon()}
          <div className="line mt12 mb12"></div> 
          {this._deposit()}
          {this._renderFooter()}
        </div>
    </div>
  }
}

const mapState =  connect(state => {
  const { orderReducer } = state
  return { orderReducer }
});
export default mapState(OrderPage);